export default __webpack_public_path__ + "static/Indian-oil-6eadfca41f24df5cb682667c3c74a948.svg";